// extracted by mini-css-extract-plugin
export default {"timetables":"WorkshopTimeTable_timetables__6yTJ8","addBtn":"WorkshopTimeTable_addBtn__-D6gV","headerBtnName":"WorkshopTimeTable_headerBtnName__p8vGd"};